<template>
	<div>
		<div class="row1">
			<div>
				<el-button @click="onAdd" class="row-btn add" type="primary" size="small">增加</el-button>
				<el-button @click="onDel" class="row-btn del" type="primary" size="small">删除</el-button>
			</div>
		</div>
		<div class="tab-box">
			<el-table
				v-loading="loading"
				element-loading-text="加载中"
				:header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column label="序号">
					<template slot-scope="scope">
						{{ scope.row.id }}
					</template>
				</el-table-column>
				<el-table-column prop="title" label="角色"></el-table-column>
				<el-table-column label="组长">
					<template slot-scope="scope">
						{{ scope.row.groupLeader ? scope.row.groupLeader.name : '' }}
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<el-switch
						@change="change(scope.row)"
						  v-model="scope.row.status == 1">
						</el-switch>
						{{ scope.row.status == 1 ? '启用' : '禁用' }}
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间"></el-table-column>
				<el-table-column label="操作" width="300" align="center">
					<template slot-scope="scope">
						<div class="handle-box">
							<span class="txt-btn txtC" @click="handleEdit(scope.row)">修改</span>
							<span class="txt-btn txtC" @click="handleAuthorize(scope.row)">授权</span>
							<span class="txt-btn del-txt" @click="handleDel(scope.row)">删除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="page-box">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 15, 20, 30, 50, 100]"
					:page-size="10"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
		<!-- 添加角色弹框 -->
		<add-role :title="title" 
		:users="users"
		:disabled="disabled" 
		@addRole="addRole" 
		@editRole="editRole" 
		ref="detailDialog"></add-role>
		<!-- 授权弹框 -->
		<authorize @saveAuthorize="saveAuthorize" ref="authorizeDialog"></authorize>
	</div>
</template>

<script>
import addRole from '../../components/dialog/addRole.vue';
import authorize from '../../components/dialog/authorize.vue';
export default {
	components: {
		addRole,
		authorize
	},
	data() {
		return {
			sValue:'',
			disabled: false,
			title: '新建角色',
			tableData: [],
			pageObj: {
				limit: 10,
				page: 1
			},
			total: 0, //总条数
			multipleSelection: [], //勾选的数据
			currentPage: 1, //当前页
			loading: true ,//是否显示加载中图标
			users:[]
		};
	},
	created() {
		this.getList();
		this.getuser()
	},
	methods: {
		getuser(){
			this.$api.usrList().then((res)=>{
				if(res.code == 1){
					this.users = res.data
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		//授权
		saveAuthorize(e){
			console.log(e);
			// if(e.node == '[]'){
			if(!e.isClick){
				e.node = '[' + this.$refs.authorizeDialog.checkedArr + ']'
			}
			delete e.isClick
			this.$api2.saveAuthorize(e).then((res)=>{
				if(res.code == 1){
					this.$message.success(res.msg)
					 this.$refs.authorizeDialog.authorizeDialog = false;
					 this.getList()
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		// 授权弹框
		handleAuthorize(v){
			this.$refs.authorizeDialog.id = v.id
			this.$refs.authorizeDialog.checkedArr = []
			this.$api2.authorizeTree({id:v.id}).then((res)=>{
				if(res.code == 1){
					this.$refs.authorizeDialog.data = res.data
					res.data.forEach((v,k)=>{
						v.children.forEach((item,key)=>{
							if(item.checked){
								this.$refs.authorizeDialog.checkedArr.push(item.id)
							}
						})
					})
					// console.log(this.$refs.authorizeDialog.checkedArr);
					this.$refs.authorizeDialog.ruleForm.title = v.title
					this.$refs.authorizeDialog.authorizeDialog = true;
				}else{
					this.$message.error(res.msg)
				}
			})
			// console.log(v.title);
			
		},
		// 启用/禁用
		change(data){
			let obj = {
				id:data.id,
				field:'status',
				value:data.status == 1 ? 0 : 1
			}
			this.$api.authState(obj).then((res)=>{
				if(res.code == 1){
					this.$message.success(data.status == 1?'已禁用':'已启用')
					this.getList()
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		// 添加角色
		addRole(data){
			this.$api.addRole(data).then((res)=>{
				if(res.code == 1){
					this.$message.success(res.msg)
					this.$refs.detailDialog.$refs["ruleForm"].resetFields()//清空输入的表单
					this.$refs.detailDialog.dialogVisible = false;
					this.getList()
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		// 修改
		editRole(data){
			let obj = {
				id:data.id,
				title:data.title,
				remark:data.remark,
				group_leader:data.group_leader
			}
			this.$api.editRole(obj).then((res)=>{
				if(res.code == 1){
					this.$message.success(res.msg)
					this.$refs.detailDialog.dialogVisible = false;
					this.getList()
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		//修改弹框
		handleEdit(v){
			this.title = '修改角色';
			this.disabled = true;
			this.$refs.detailDialog.ruleForm = {
				remark:v.remark,
				title:v.title,
				id:v.id,
				group_leader:v.group_leader == 0?'':v.group_leader
			}
			this.$refs.detailDialog.dialogVisible = true;
		},
		// 添加弹框
		onAdd() {
			for(let key in this.$refs.detailDialog.ruleForm){
				this.$refs.detailDialog.ruleForm[key] = ""
			}
			this.disabled = false;
			this.$refs.detailDialog.dialogVisible = true;
		},
		// 删除
		handleDel(v){
			this.$confirm('确认删除：'+v.title+' ？', '提示').then(() => {
				 this.$api.delRole({id:v.id}).then((res)=>{
				 	if(res.code == 1){
				 		this.$message.success(res.msg)
				 		this.getList()
				 	}else{
				 		this.$message.error(res.msg)
				 	}
				 })
			}).catch(()=>{})
		},
		//删除多项
		onDel() {
			if (!this.multipleSelection.length) return this.$message.error('请勾选要删除的选项！');
			let ids = []
			this.multipleSelection.forEach((v,k)=>{
				ids[k] = v.id
			})
			this.$confirm('确认删除？', '提示').then(() => {
				this.$api.delRole({id:ids}).then((res)=>{
					if(res.code == 1){
						this.$message.success(res.msg)
						this.getList()
					}else{
						this.$message.error(res.msg)
					}
				})
			}).catch(()=>{})
		},
		// 获取数据列表
		getList() {
			this.loading = true;
			this.$api
				.roleList(this.pageObj)
				.then(res => {
					this.loading = false;
					if (res.code == 1) {
						this.total = res.count;
						this.tableData = res.data;
					}
				})
				.catch(err => {
					this.loading = false;
				});
		},
		// 多选事件
		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(val);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pageObj.limit = val;
			this.getList();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pageObj.page = val;
			this.getList();
		}
	}
};
</script>

<style lang="scss">
@import '../../assets/css/public.scss';
.handle-box {
	padding: 0 30px;
	display: flex;
	justify-content: space-around;
}
</style>
